import classNames from 'classnames';
import React from 'react';
import styles from './index.less';

const LeftBg: React.FC = () => {
  return (
    <div className={styles.leftBg}>
      <div className={styles.haloRing} />
      <div className={styles.haloRing1} />
      <div className={styles.haloRing2} />
      {/* 圆环渐变背景 */}
      <div className={styles.bgRing0} />
      <div className={styles.bgRing1} />
      <div className={styles.bgRing2} />
      <div className={styles.bgRing3} />
      {/* 浮动点和icon */}
      <div className={classNames(styles.bgDot, styles.bgDot1)} />
      <div className={classNames(styles.bgDot, styles.bgDot2)} />
      <div className={classNames(styles.bgDot, styles.bgDot3)} />
      <div className={classNames(styles.bgDot, styles.bgDot4)} />
      {/* 主要插画和气泡内容 */}
      <div className={styles.illustPanelWrap}>
        {/* 主面板插画，可用图片或渐变背景占位 */}
        <div className={styles.illustPanel}>
          <div className={styles.mdtPanelHeader}>
            <span className={styles.mdtPanelTitle}>MDT会诊</span>
            <span className={classNames(styles.mdtPanelIcon, 'iconfont', 'icon-file-text-line')} />
          </div>
          <div className={styles.mdtPanelList}>
            <div className={styles.mdtPanelListInner}>
              <div className={styles.mdtPanelListItem}>
                <span className={classNames(styles.mdtAvatar, styles.mdtAvatarBlue)} />
                <div className={styles.mdtBarWrap}>
                  <div className={classNames(styles.mdtBar, styles.mdtBar1)} />
                  <div className={classNames(styles.mdtBar, styles.mdtBar2)} />
                </div>
              </div>
              <div className={styles.mdtPanelListItem}>
                <span className={classNames(styles.mdtAvatar, styles.mdtAvatarYellow)} />
                <div className={styles.mdtBarWrap}>
                  <div className={classNames(styles.mdtBar, styles.mdtBar1)} />
                  <div className={classNames(styles.mdtBar, styles.mdtBar2)} />
                </div>
              </div>
              <div className={styles.mdtPanelListItem}>
                <span className={classNames(styles.mdtAvatar, styles.mdtAvatarPurple)} />
                <div className={styles.mdtBarWrap}>
                  <div className={classNames(styles.mdtBar, styles.mdtBar1)} />
                  <div className={classNames(styles.mdtBar, styles.mdtBar2)} />
                </div>
              </div>
              {/* 复制一份内容用于无缝滚动 */}
              <div className={styles.mdtPanelListItem}>
                <span className={classNames(styles.mdtAvatar, styles.mdtAvatarBlue)} />
                <div className={styles.mdtBarWrap}>
                  <div className={classNames(styles.mdtBar, styles.mdtBar1)} />
                  <div className={classNames(styles.mdtBar, styles.mdtBar2)} />
                </div>
              </div>
              <div className={styles.mdtPanelListItem}>
                <span className={classNames(styles.mdtAvatar, styles.mdtAvatarYellow)} />
                <div className={styles.mdtBarWrap}>
                  <div className={classNames(styles.mdtBar, styles.mdtBar1)} />
                  <div className={classNames(styles.mdtBar, styles.mdtBar2)} />
                </div>
              </div>
              <div className={styles.mdtPanelListItem}>
                <span className={classNames(styles.mdtAvatar, styles.mdtAvatarPurple)} />
                <div className={styles.mdtBarWrap}>
                  <div className={classNames(styles.mdtBar, styles.mdtBar1)} />
                  <div className={classNames(styles.mdtBar, styles.mdtBar2)} />
                </div>
              </div>
            </div>
          </div>
          <span className={styles.mdtPanelArrow} />
        </div>
        {/* 医生插画 */}
        <div className={styles.illustDoctor} />
        {/* 病例库气泡 */}
        <div className={classNames(styles.bubble, styles.bubbleCaseLib)}>
          <div className={classNames(styles.bubbleIcon, 'iconfont', 'icon-yisheng-01')} />
          <div className={styles.bubbleText}>病例库</div>
        </div>
        {/* MDT团队气泡 */}
        <div className={classNames(styles.bubble, styles.bubbleMdtTeam)}>
          <div className={classNames(styles.bubbleIcon, 'iconfont', 'icon-a-tuandui3')} />
          <div className={styles.bubbleText}>MDT团队</div>
        </div>
        {/* 视频问诊气泡 */}
        <div className={classNames(styles.bubble, styles.bubbleVideo)}>
          <div className={classNames(styles.videoIcon, 'iconfont', 'icon-video-chat-fill')} />
          <div className={styles.bubbleText}>视频问诊</div>
        </div>
        {/* 患者档案管理气泡 */}
        <div className={classNames(styles.bubble, styles.bubblePatient)}>
          <div className={classNames(styles.bubbleIcon, 'iconfont', 'icon-tianchongxing-4')} />
          <div className={styles.bubbleText}>患者档案管理</div>
        </div>
        {/* 扫描 */}
        <div className={styles.bubbleCard}>
          <div className={styles.bubbleCardInner}>
            <div className={classNames(styles.avatar, 'iconfont icon-gerenzhongxinsel')} />
            <div className={styles.scanLineWrap}>
              <div className={styles.scanLine} />
            </div>
            <div className={styles.contentLine} />
            <div className={styles.contentLineShort} />
            <div className={styles.contentLineShort} style={{ width: '80%' }} />
          </div>
        </div>
        <div className={styles.bubbleWebCard} />
      </div>
      <div
        className={classNames(styles.floatBubble, styles.floatBubble1, 'iconfont icon-bingli')}
        style={{ top: '80%', left: '16%', width: 24, height: 24, animationDelay: '0s' }}
      />
      <div
        className={classNames(
          styles.floatBubble,
          styles.floatBubble2,
          'iconfont icon-image-2-fill',
        )}
        style={{ top: '9%', left: '27%', width: 18, height: 18, animationDelay: '1.2s' }}
      />
      <div
        className={classNames(styles.floatBubble, styles.floatBubble3)}
        style={{ top: '22%', left: '48%', width: 10, height: 10, animationDelay: '0.2s' }}
      />
      <div
        className={classNames(styles.floatBubble, styles.floatBubble4, 'iconfont icon-a-5')}
        style={{ top: '20%', left: '82%', width: 32, height: 32, animationDelay: '0.6s' }}
      />
      <div
        className={classNames(
          styles.floatBubble,
          styles.floatBubble5,
          'iconfont icon-tianchongxing-2',
        )}
        style={{ bottom: '20%', right: '25%', width: 20, height: 20, animationDelay: '1s' }}
      />
      <div
        className={classNames(
          styles.floatBubble,
          styles.floatBubble6,
          'iconfont icon-huanzheliebiao',
        )}
        style={{ bottom: '9%', right: '61%', width: 12, height: 12, animationDelay: '1s' }}
      />
      <div
        className={classNames(styles.floatBubble, styles.floatBubble7, 'iconfont icon-a-huaban4')}
        style={{ bottom: '36%', right: '9%', width: 12, height: 12, animationDelay: '0.2s' }}
      />
    </div>
  );
};

export default LeftBg;
